export default "/assets/images/smoky-gray-sm.jpg?11370a72f5debcf23aa76c36d7e5e268";